import permissions from './permissions.json'

enum Roles {
  QUEST_USER = 1,
  QUEST_ADMIN = 2,
}

enum Rules {
  OWNER = 1,
  MEMBER = 2,
  NOT_OWNER_AND_MEMBER = 3,
  ADMINS = 4,
}

export default {
  permissions: [
    {
      name: permissions.WORKSPACE.PERMISSION,
      label: 'Страница рабочего стола',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.WORKSPACE.SHOW_REPORT_BTN.PERMISSION,
      label: 'Показать кнопку отчётов на рабочем столе',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.LK.PROFILE.PERMISSION,
      label: 'Страница личного кабинета профиля',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.LK.ADDRESS.PERMISSION,
      label: 'Страница личного кабинета для добавления адреса',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.LK.NOTIFICATIONS.PERMISSION,
      label: 'Страница личного кабинета для настройки уведомлений',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.LK.SECURITY.PERMISSION,
      label: 'Страница личного кабинета для настройки безопасности',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.PERMISSION,
      label: 'Раздел для работы с проектами',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.SHOW_ENTER_TO_PROJECT.PERMISSION,
      label: 'Показать кнопку вступления в проект для карточки',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.NOT_OWNER_AND_MEMBER],
    },
    {
      name: permissions.PROJECTS.SHOW_NAVIGATE_TO_PROJECT.PERMISSION,
      label: 'Показать кнопку перехода в проект для карточки',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.MEMBER],
    },
    {
      name: permissions.PROJECTS.ALL.PERMISSION,
      label: 'Страница всех проектов',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.MY.PERMISSION,
      label: 'Страница моих проектов',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.FAVORITE.PERMISSION,
      label: 'Страница избранных проектов',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.REQUESTS.PERMISSION,
      label: 'Страница заявок на проект',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.REQUESTS.GET_ALL_REQUESTS.PERMISSION,
      label: 'Получение всех заявок на проект',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      id: 14,
      name: permissions.PROJECTS.REQUESTS.SHOW_NAVIGATION_BUTTON.PERMISSION,
      label: 'Показать кнопку для перехода на согласование проекта',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      id: 15,
      name: permissions.PROJECTS.REQUESTS.APPROVAL.PERMISSION,
      label: 'Страница согласования заявок на проект',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.REQUESTS.CREATE.PERMISSION,
      label: 'Страница создания заявки на проект',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.REQUESTS.CREATE.ONLY_PROJECT.PERMISSION,
      label: 'Возможность создавать проект без заявки',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.REQUESTS.EDIT.PERMISSION,
      label: 'Страница редактирования (заявки на) проект',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.REQUESTS.MODULE_CREATE_SELECT.PERMISSION,
      label: 'Выбор типа кастомного модуля при заполнении заявки на проект',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.REQUESTS.CUSTOM_MODULE_CREATE.PERMISSION,
      label: 'Оформление кастомного модуля при заполнении заявки на проект',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.PERMISSION,
      label: 'Страница рабочего стола проекта',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.MEMBER],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.MEMBERS.PERMISSION,
      label: 'Страница участников проекта',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.MEMBER],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.MEMBERS.SHOW_DELETE_MEMBER.PERMISSION,
      label: 'Показать кнопку для удаления участника из команды',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.MEMBERS.SHOW_ADD_MEMBER.PERMISSION,
      label: 'Показать добавление участников',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.MEMBERS.INVITE.PERMISSION,
      label: 'Страница для приглашения в участники проекта',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.FRIENDS.PERMISSION,
      label: 'Страница друзей',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.USER.PERMISSION,
      label: 'Страница пользователя',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.USER.FRIENDS.PERMISSION,
      label: 'Страница друзей пользователя',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.USER.SHOW_DETAILED_INFORMATION.PERMISSION,
      label: 'Показать подробную информацию на странице пользователя',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.PROJECT.PERMISSION,
      label: 'Страница о проекте (глазами другого пользователя)',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.SHOW_MANAGEMENT_BLOCK.PERMISSION,
      label: 'Показать блок с управлением',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.SHOW_MEMBERS_BLOCK.PERMISSION,
      label: 'Показать блок с участниками',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.SHOW_SUPPORTERS_BLOCK.PERMISSION,
      label: 'Показать блок с сторонниками',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER],
    },
    {
      name: permissions.PROJECTS.SHOW_CREATE_PROJECT_WITH_TEMPLATES_BTN.PERMISSION,
      label: 'Показать кнопку для создания проекта с шаблонами',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.ABOUT.SHOW_SELECTION_TEMPLATE_BTN.PERMISSION,
      label: 'Показать кнопку выбора шаблона на лендинге проекта',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.ABOUT.SHOW_SELECTION_EDIT_TEMPLATE_BTN.PERMISSION,
      label: 'Показать кнопку редактирования шаблона на лендинге проекта',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY.SHOW_ARCHIVE_TAB.PERMISSION,
      label: 'Показать вкладку архива обращений',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY.SHOW_STATISTICS_TAB.PERMISSION,
      label: 'Показать вкладку статистики обращений',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.QUESTION_TO_DEPUTY.SHOW_CREATE_SURVEY_BTN.PERMISSION,
      label: 'Показать кнопку создания обращения',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.RIGHTS_OF_CONSUMER.SHOW_CREATE_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку создания права потребителя',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.RIGHTS_OF_CONSUMER.SHOW_EDIT_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку редактирования права потребителя',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.RIGHTS_OF_CONSUMER.SHOW_DELETE_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку удаления права потребителя',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.WHAT_TO_DO_IN_CASE_OF_ACCIDENT.SHOW_CREATE_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку создания что делать при аварии',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.WHAT_TO_DO_IN_CASE_OF_ACCIDENT.SHOW_EDIT_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку редактирования что делать при аварии',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.WHAT_TO_DO_IN_CASE_OF_ACCIDENT.SHOW_DELETE_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку удаления что делать при аварии',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.MY_SPEECH.SPEECH_REVIEW.PERMISSION,
      label: 'Страница согласования заявки на выступление',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.ENTERTAINMENT.SHOW_CREATE_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку создания новости для развлечений',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.ENTERTAINMENT.SHOW_EDIT_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку редактирования новости для развлечений',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.ENTERTAINMENT.SHOW_DELETE_NEWS_BTN.PERMISSION,
      label: 'Показать кнопку удаления новости для развлечений',
      roles: [Roles.QUEST_ADMIN],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.EMERGENCY_CONTACTS.SHOW_CREATE_BTN.PERMISSION,
      label: 'Показать кнопку для создания сторонника',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.EMERGENCY_CONTACTS.SHOW_EDIT_BTN.PERMISSION,
      label: 'Показать кнопку для редактирования сторонника',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
    {
      name: permissions.PROJECTS.WORKSPACE.EMERGENCY_CONTACTS.SHOW_DELETE_BTN.PERMISSION,
      label: 'Показать кнопку для удаления сторонника',
      roles: [Roles.QUEST_USER, Roles.QUEST_ADMIN],
      rules: [Rules.OWNER, Rules.ADMINS],
    },
  ],
  roles: [
    {
      id: Roles.QUEST_USER,
      name: 'quest-user',
    },
    {
      id: Roles.QUEST_ADMIN,
      name: 'quest-admin',
    },
  ],
  rules: [
    {
      id: Rules.OWNER,
      name: 'owner',
    },
    {
      id: Rules.MEMBER,
      name: 'member',
    },
    {
      id: Rules.NOT_OWNER_AND_MEMBER,
      name: 'not-owner-and-member',
    },
    {
      id: Rules.ADMINS,
      name: 'admins',
    },
  ],
}
